import React from "react";
import { DocumentTitle, type DocumentTitleProps } from "@shared/components/document-title";
import { useAuthStore } from "@app/store/useAuthStore";

/**
 * App-level биндинг заголовка документа.
 *
 * Добавляет к shared {@link DocumentTitle} инфраструктурный postfix текущего сервера,
 * чтобы страницы задавали только смысловой заголовок.
 */
export const AppDocumentTitle: React.FC<Omit<DocumentTitleProps, "postfix">> = (props) => {
    const postfix = useAuthStore((state) => state.server?.documentPostfixTitle);

    return <DocumentTitle {...props} postfix={postfix} />;
};
